import { FormControl, InputLabel, makeStyles, Select as MuiSelect } from '@material-ui/core';
import React, { PropsWithChildren } from 'react';
import { useBoolean } from 'react-use-boolean';
import { paperStyle } from './Paper';

type Value = string | number;

export interface SelectProps<T extends Value> {
  value: T;
  onChange: (value: T) => void;
  label: string;
  id: string;
}

const usePaperStyle = makeStyles(paperStyle);

export const HorizontalSelect = <T extends Value>({
  id,
  value,
  onChange,
  label,
  children,
}: PropsWithChildren<SelectProps<T>>): JSX.Element => {
  const paperStyle = usePaperStyle({});
  const [open, actions] = useBoolean();
  const labelId = `${id}-label`;

  return (
    <FormControl onClick={actions.on}>
      <InputLabel disableAnimation id={labelId}>
        {label}
      </InputLabel>
      <MuiSelect
        open={open}
        onClose={actions.off}
        onOpen={actions.on}
        labelId={labelId}
        label={label}
        id={id}
        value={value}
        onChange={({ target }) => onChange(target.value as T)}
        MenuProps={{ classes: { paper: paperStyle.root } }}
      >
        {children}
      </MuiSelect>
    </FormControl>
  );
};
